import Vue from 'vue'
import Router from 'vue-router'
// pc端
import Homepage from '@/components/homepage/index'
import Details from '@/components/details/index'
import ContentList from '@/components/contentList/index'
// 时政快讯  
import CurrentPolitics from '@/components/otherNavigation/currentPolitics'
//公示公告
import Announcement from '@/components/otherNavigation/announcement'
// 濮阳要闻 
import ImportantNews from '@/components/otherNavigation/importantNews'
// 综合新闻   
import ComprehensiveNews from '@/components/otherNavigation/comprehensiveNews'
// 龙乡新闻 
import LongxiangNews from '@/components/otherNavigation/longxiangNews'
// 喜迎二十大 
import HappyErShiDa from '@/components/otherNavigation/happyErShiDa'
// 手机报 
import Announphones from '@/components/otherNavigation/announphones'
//栏目         
import ColumnList from '@/components/homepage/components/columnList'
import ColumnAllLists from '@/components/homepage/components/columnAllLists'


// 移动端
import Mindex from '@/components/appModule/index'

import DetailsList from '@/components/appModule/homePageApp/appContentList/detailsList/index'
import ListDetailsApp from '@/components/appModule/homePageApp/appContentList/listDetailsApp/index'

//   
import PushIndex from '@/components/appModule/homePageApp/appContentList/detailsList/pushIndex'

// 检索   
import RetrieveList from '@/components/appModule/homePageApp/appContentList/detailsList/retrieveList'
import RetrieveListTwo from '@/components/appModule/homePageApp/appContentList/detailsList/retrieveListTwo'
import XjpTime from '@/components/appModule/homePageApp/appContentList/detailsList/xjpTime'
import CurrentPoliticsa from '@/components/appModule/homePageApp/appContentList/detailsList/currentPolitics'
import PublicList from '@/components/appModule/homePageApp/appContentList/detailsList/publicList'
import NewsList from '@/components/appModule/homePageApp/appContentList/detailsList/newsList'
import LxList from '@/components/appModule/homePageApp/appContentList/detailsList/lxList'
import ComprehensiveList from '@/components/appModule/homePageApp/appContentList/detailsList/comprehensiveList'
import PhoneList from '@/components/appModule/homePageApp/appContentList/detailsList/phoneList'




Vue.use(Router)

export default new Router({
        // mode: 'history',
        routes: [
            // pc端
            {
                path: '/',
                name: 'Homepage',
                component: Homepage,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,

                }
            },
            // 列表
            {
                path: '/contentList',
                name: 'contentList',
                component: ContentList,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            // 详情页
            {
                path: '/details',
                name: 'details',
                component: Details,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/alerts',
                name: 'currentPolitics',
                component: CurrentPolitics,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/announcement',
                name: 'announcement',
                component: Announcement,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/importantnews',
                name: 'importantNews',
                component: ImportantNews,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/comprehensivenews',
                name: 'comprehensiveNews',
                component: ComprehensiveNews,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/longxiangnews',
                name: 'longxiangNews',
                component: LongxiangNews,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/happyErShiDa',
                name: 'happyErShiDa',
                component: HappyErShiDa,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/announphones',
                name: 'Announphones',
                component: Announphones,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/columnlist',
                name: 'columnList',
                component: ColumnList,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },
            {
                path: '/columnlists',
                name: 'columnAllLists',
                component: ColumnAllLists,
                meta: {
                    title: '濮阳县新闻网',
                    requireAuth: true,
                }
            },


            // 移动端  columnAllLists
            {
                path: '/m_index',
                name: 'm_index',
                component: Mindex
            },
            {
                path: '/detailsList',
                name: 'detailsList',
                component: DetailsList
            },
            {
                path: '/listDetailsApp',
                name: 'listDetailsApp',
                component: ListDetailsApp
            },
            {
                path: '/retrieveList',
                name: 'retrieveList',
                component: RetrieveList
            }, {
                path: '/retrieveListTwo',
                name: 'RetrieveListTwo',
                component: RetrieveListTwo
            },
            {
                path: '/recommended',
                name: 'pushIndex',
                component: PushIndex
            },
            {
                path: '/xjptime',
                name: 'xjpTime',
                component: XjpTime
            },
            {
                path: '/currentpoliticsa',
                name: 'currentPoliticsa',
                component: CurrentPoliticsa
            },
            {
                path: '/publiclist',
                name: 'publicList',
                component: PublicList
            },
            {
                path: '/newslist',
                name: 'newsList',
                component: NewsList
            },
            {
                path: '/lxlist',
                name: 'lxList',
                component: LxList
            },
            {
                path: '/comprehensivelist',
                name: 'comprehensiveList',
                component: ComprehensiveList
            },
            {
                path: '/phonelist',
                name: 'phoneList',
                component: PhoneList
            }
        ]
    })
    //   PhoneList

// if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

//   // router.push({name:"mobile"})        //判断是否为移动端的设备，是移动端的话  跳转  mobile 页面

//                 alert(1)                                          //否则为pc端  跳转index页面

//   }else{

//   // router.push({name:"index"})
//   alert(2)

//   }

// export default router    //记得加这一行代码


// WEBPACK FOOTER //
// ./src/router/index.js